import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from "@angular/common/http";
import {
  CashVoucherListingRequestInterface,
  CashVoucherListingResponseInterface,
  CashVoucherDeactivateResultInterface
} from '../_interfaces/cashVouchers.interface';
import {
  ExternalVoucherListingRequestInterface,
  ExternalVoucherListingResponseInterface,
  ExternalVoucherDeactivateResultInterface,
  ExternalVoucherPartnerListingInterface
} from '../_interfaces/externalVouchers.interface';

@Injectable({
  providedIn: 'root'
})
export class VouchersDataService {
  private cashVoucherBasePath: string = `${environment.url}/api/CashVouchers`;
  private externalVoucherBasePath: string = `${environment.url}/api/ExternalVouchers`;

  constructor(
    private http: HttpClient
  ) {

  }

  //#region Cash Voucher Module
  
  getCashVoucherListing(request: CashVoucherListingRequestInterface) {
    return this.http.post<CashVoucherListingResponseInterface>(
      `${this.cashVoucherBasePath}/GetListing`,
      request,
    );
  }

  exportCashVoucherListingExcel(request: CashVoucherListingRequestInterface) {
    return this.http.post(
      `${this.cashVoucherBasePath}/ExportListingExcel`,
      request,
      { responseType: "blob" }
    );
  }

  downloadCashVoucherExcelTemplate() {
    return this.http.get(
      `${this.cashVoucherBasePath}/DownloadCashVoucherExcelTemplate`,
      { responseType: "blob" }
    );
  }

  getExternalVoucherPartnerListing() { 
    return this.http.post<ExternalVoucherPartnerListingInterface>(
      `${this.externalVoucherBasePath}/GetExternalVoucherPartnerListing`,
      {} 
    );
  }

  deactivateCashVoucher(selectedVoucherId: string | null) {
    return this.http.post<CashVoucherDeactivateResultInterface>(
      `${this.cashVoucherBasePath}/DeactivateVoucher`,
      { selectedVoucherId }
    );
  }

  //#endregion

  //#region External Voucher Module
  
  getExternalVoucherListing(request: ExternalVoucherListingRequestInterface) {
    return this.http.post<ExternalVoucherListingResponseInterface>(
      `${this.externalVoucherBasePath}/GetListing`,
      request,
    );
  }

  exportExternalVoucherListingExcel(request: ExternalVoucherListingRequestInterface) {
    return this.http.post(
      `${this.externalVoucherBasePath}/ExportListingExcel`,
      request,
      { responseType: "blob" }
    );
  }

  downloadExternalVoucherExcelTemplate() {
    return this.http.get(
      `${this.externalVoucherBasePath}/DownloadExternalVoucherExcelTemplate`,
      { responseType: "blob" }
    );
  }

  deactivateExternalVoucher(selectedVoucherId: string | null) {
    return this.http.post<ExternalVoucherDeactivateResultInterface>(
      `${this.externalVoucherBasePath}/DeactivateVoucher`,
      { selectedVoucherId }
    );
  }

  //#endregion
}
